import {
	BaseAPIResponse,
	CreateHiringAssessmentInput,
	GetHiringAssessmentDashboardResponse,
	GetHiringAssessmentListResponse,
	GetHiringAssessmentMetaResponse,
	GetHiringAssessmentResponse,
	GuestUserValidateJwtAPIResponse,
	GuestUserVerifyOTPResponse,
	InviteAssessementBulkAction,
	PostHiringAssessmentResponse,
	UserExperienceLevelType,
	UserPreferenceType,
} from 'types';
import { baseApi } from './axios';
import { API_ENDPOINT } from 'src/config/env.config';

const baseUrl = `${API_ENDPOINT}/hiringAssessment`;

export const hiringAssessmentDashboard = async (): Promise<GetHiringAssessmentDashboardResponse> => {
	const response = await baseApi.get(`${baseUrl}/hiringAssessmentDashboard`);
	return response.data;
};

export const getAllHiringAssessments = async ({ id }: { id?: string }): Promise<GetHiringAssessmentListResponse> => {
	const response = await baseApi.get(`${baseUrl}/getAllHiringAssessments`, { params: { id } });
	return response.data;
};

export const createHiringAssessment = async ({
	userPreferenceSnapshot,
	salaryRange,
	gaugingCandidateStatus,
	assessmentDeadline,
	skills,
	workingMode,
}: CreateHiringAssessmentInput): Promise<PostHiringAssessmentResponse> => {
	const response = await baseApi.post(`${baseUrl}/createHiringAssessment`, {
		userPreferenceSnapshot,
		salaryRange,
		gaugingCandidateStatus,
		assessmentDeadline,
		skills,
		workingMode,
	});
	return response.data;
};

export const updateHiringAssessment = async ({
	id,
	hiringAssessmentDeadline,
}: {
	id: string;
	hiringAssessmentDeadline: Date;
}) => {
	const response = await baseApi.put(`${baseUrl}/updateHiringAssessment/${id}`, {
		hiringAssessmentDeadline,
	});
	return response.data;
};

export const getHiringAssessmentSkills = async (data: { userPreferenceSnapshot: UserPreferenceType }) => {
	const response = await baseApi.post(`${baseUrl}/getHiringAssessmentSkills`, data);
	return response.data;
};

export const guestUserSendOtp = async ({
	email,
	name,
	experienceLevel,
}: {
	email: string;
	name: string;
	experienceLevel: UserExperienceLevelType;
}): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/guestUserSendOtp`, {
		email,
		name,
		experienceLevel,
	});
	return response.data;
};

export const guestUserVerifyOtp = async ({
	email,
	name,
	experienceLevel,
	otp,
}: {
	email: string;
	otp: string;
	name: string;
	experienceLevel: UserExperienceLevelType;
}): Promise<GuestUserVerifyOTPResponse> => {
	const response = await baseApi.post(`${baseUrl}/guestUserVerifyOtp`, {
		email,
		otp,
		name,
		experienceLevel,
	});
	return response.data;
};

export const guestUserValidateJwt = async ({ token }: { token: string }): Promise<GuestUserValidateJwtAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/guestUserValidateJwt`, {
		token,
	});
	return response.data;
};

export const getHiringAssessment = async ({
	hiringAssessmentId,
	token,
}: {
	hiringAssessmentId: string;
	token: string;
}): Promise<GetHiringAssessmentResponse> => {
	console.log('API Debug: hiringAssessmentId', hiringAssessmentId);
	const response = await baseApi.post(`${baseUrl}/getHiringAssessment/${hiringAssessmentId}`, {
		token,
	});
	return response.data;
};
export const getHiringAssessmentMeta = async ({
	hiringAssessmentId,
}: {
	hiringAssessmentId: string;
}): Promise<GetHiringAssessmentMetaResponse> => {
	const response = await baseApi.post(`${baseUrl}/getHiringAssessmentMeta/${hiringAssessmentId}`);
	return response.data;
};

export const inviteAssessementBulkAction = async (payload: InviteAssessementBulkAction): Promise<BaseAPIResponse> => {
	const response = await baseApi.patch(`${baseUrl}/inviteAssessementBulkAction`, payload);
	return response.data;
};

export const copyHiringAssessmentLink = async ({
	companyId,
	hiringAssessmentId,
	type,
}: {
	companyId: string;
	hiringAssessmentId: string;
	type: 'link' | 'message';
}): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/copyHiringAssessmentLink`, {
		companyId,
		hiringAssessmentId,
		type,
	});
	return response.data;
};
